import { useState } from "react";
import OperacionesIncluirOperacionNoReportada from "./OperacionesIncluirOperacionNoReportada";

function SolicitudIncluirOperacionNoReportada({
  datosSolicitud,
  actualizarDatosTipoSolicitud,
}) {
  const [datosSolicitudLocal, setDatosSolicitudLocal] = useState({
    operaciones: datosSolicitud.operaciones,
  });

  function actualizarOperaciones(operaciones) {
    const nuevosDatos = {
      ...datosSolicitudLocal,
      operaciones: operaciones,
    };
    actualizarDatos(nuevosDatos);
  }

  function actualizarDatos(nuevosDatos) {
    setDatosSolicitudLocal(nuevosDatos);
    actualizarDatosTipoSolicitud(nuevosDatos);
  }

  return (
    <>
      <OperacionesIncluirOperacionNoReportada
        operaciones={datosSolicitudLocal.operaciones}
        actualizarOperaciones={actualizarOperaciones}
        permiteEditar="true"
        permiteEliminar="true"
      />
    </>
  );
}

export default SolicitudIncluirOperacionNoReportada;
